import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';

export class GoogleAnalyticsController
{
    public isInitialized():boolean
    {
        return !!(window as any).gtag;
    }

    public gtag(action:AnalyticsEventActions, value:any = {}):void
    {
        // console.log('%c *** GoogleAnalyticsController gtag =', 'background:#0f0;color:#000;', action);
        // console.log('%c value =', 'background:#080;color:#000;', value);

        if( !this.isInitialized() )
        {
            if( ConfigUtil.useAnalytics() )
                console.log('%c GOOGLE Analytics gtag NOT DEFINED ', 'background:#f00;color:#ff0;');
                
            return;
        }

        if( action === AnalyticsEventActions.GA_CONVERSION )
        {
            (window as any).gtag('event', 'conversion', {
                'send_to': 'AW-706148233/j4TKCNzgtqwBEInv29AC'
            });
        }
        else
        {
            // value.timestamp = new Date();

            let [event_category, event_label] = (action as string).split('__');

            const eventInfo = GoogleAnalyticsEventInfo[action];

            if( eventInfo && eventInfo.category ) event_category = eventInfo.category;
            if( eventInfo && eventInfo.label ) event_label = eventInfo.label;

            // https://developers.google.com/analytics/devguides/collection/gtagjs/limits-quotas#client_libs_sdks
            // TODO: Each gtag.js and analytics.js tracker object starts with 20 hits that are replenished at a rate of 2 hits per second.
            // TODO: This limit applies to all hits except for ecommerce (item or transaction).

            (window as any).dataLayer.push({
                event: 'event-to-ga',
                event_category,
                event_action: action,
                event_label
            });

            // (window as any).gtag('event', action, {
            //     event_category,
            //     event_label,
            //     value: JSON.stringify(value),
            //     MD_Timestamp: this.getTimestamp(new Date())
            // });
        }
    }

    /**
     * Returns custom timestamp for GA
     * @param {Date} date
     * @returns {string} "2019-09-21 15:31:58 GMT+0300"
     */
    public getTimestamp(date:Date):string
    {
        const pad = (num:number) => num < 10 ? '0' + num : '' + num;

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();

        const str = date.toString();
        const time = str.substr(16, 17); // "15:31:58 GMT+0300"

        return `${year}-${month}-${day} ${time}`;
    }
}

export interface IGoogleAnalyticsEventInfo
{
    category:string;
    label:string;
}

export const GoogleAnalyticsEventInfo:{[key:string]:IGoogleAnalyticsEventInfo} = {
    // user_enter
    // ---------------------------------------------------
    [AnalyticsEventActions.WSP_SIGNUP_FIRST_PAGE_LANDED]: {
        category: 'user_enter',
        label: 'Signup first page landed',
    },
    [AnalyticsEventActions.WSP_SIGNUP_FIRST_PAGE_LOADED]: {
        category: 'user_enter',
        label: 'Signup first page loaded',
    },
    [AnalyticsEventActions.WSP_LOGIN_FIRST_PAGE_LANDED]: {
        category: 'user_enter',
        label: 'Login first page landed',
    },
    [AnalyticsEventActions.WSP_LOGIN_FIRST_PAGE_LOADED]: {
        category: 'user_enter',
        label: 'Login first page loaded',
    },

    // user_invite
    // ---------------------------------------------------
    [AnalyticsEventActions.WSP_INVITE_SENT]: {
        category: 'user_invite',
        label: 'Invite sent',
    },
    [AnalyticsEventActions.WSP_INVITE_NEW_USER_LOADED]: {
        category: 'user_invite',
        label: 'Invite new user loaded',
    },
    [AnalyticsEventActions.WSP_INVITE_NEW_USER_CONFIRMED_ORG]: {
        category: 'user_invite',
        label: 'Invite new user confirmed org',
    },
    [AnalyticsEventActions.WSP_INVITE_NEW_USER_FIRST_PAGE_LANDED]: {
        category: 'user_invite',
        label: 'Invite new user first page landed',
    },
    [AnalyticsEventActions.WSP_INVITE_NEW_USER_FIRST_PAGE_LOADED]: {
        category: 'user_invite',
        label: 'Invite new user first page loaded',
    },

    // wsp_usage
    // ---------------------------------------------------
    [AnalyticsEventActions.WSP_ORG_CREATED]: {
        category: 'wsp_usage',
        label: 'Org created',
    },
    [AnalyticsEventActions.WSP_PROFILE_NAME_EDITED]: {
        category: 'wsp_usage',
        label: 'Profile name edited',
    },
    [AnalyticsEventActions.WSP_PROFILE_CHANGED_PASSWORD]: {
        category: 'wsp_usage',
        label: 'Profile changed password',
    },

    [AnalyticsEventActions.WSP_PAGE_LANDED]: {
        category: 'wsp_usage',
        label: 'Page landed',
    },
    [AnalyticsEventActions.WSP_PAGE_LOADED]: {
        category: 'wsp_usage',
        label: 'Page loaded',
    },

    [AnalyticsEventActions.WSP_DESIGN_CREATED]: {
        category: 'wsp_usage',
        label: 'Design created',
    },
    [AnalyticsEventActions.WSP_SPACE_CREATED]: {
        category: 'wsp_usage',
        label: 'Space created',
    },
    [AnalyticsEventActions.WSP_ORG_SWITCHED]: {
        category: 'wsp_usage',
        label: 'Org switched',
    },
    [AnalyticsEventActions.WSP_DESIGN_RENAMED]: {
        category: 'wsp_usage',
        label: 'Design renamed',
    },
    [AnalyticsEventActions.WSP_DESIGN_DUPLICATED]: {
        category: 'wsp_usage',
        label: 'Design duplicated',
    },
    [AnalyticsEventActions.WSP_DESIGN_MOVED]: {
        category: 'wsp_usage',
        label: 'Design moved',
    },

    // wsp_design_usage
    // ---------------------------------------------------
    [AnalyticsEventActions.WSP_DESIGN_OPEN_CLICKED]: {
        category: 'wsp_design_usage',
        label: 'Design open clicked',
    },
    [AnalyticsEventActions.WSP_DESIGN_PUBLISHED]: {
        category: 'wsp_design_usage',
        label: 'Design published',
    },

    // wsp_designer_usage
    // ---------------------------------------------------
    [AnalyticsEventActions.WSP_DESIGNER_LANDED]: {
        category: 'wsp_designer_usage',
        label: 'Designer landed',
    },
    [AnalyticsEventActions.WSP_DESIGNER_FIRST_RENDER]: {
        category: 'wsp_designer_usage',
        label: 'Designer first render',
    },
    [AnalyticsEventActions.WSP_DESIGNER_LOADED]: {
        category: 'wsp_designer_usage',
        label: 'Designer loaded',
    },
    [AnalyticsEventActions.WSP_DESIGNER_ACTIVE]: {
        category: 'wsp_designer_usage',
        label: 'Designer active',
    },
};
